export enum TabViewMode {
  UserList = 'user-list',
  AuditLog = 'audit-log',
}

export enum UserStatus {
  Pending,
  Active,
  Inactive,
}

export enum FieldChanged {
  Status = 'Status',
  Role = 'Role',
}
